module.exports = require("lodash/orderBy");